module.exports = __webpack_public_path__ + "img/express.99822c58.svg";